import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import { Theme } from '../../config/theme';

export default class OrderSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  render() {
    const price = this.props.promoPrice !== null
      ? this.props.promoPrice
      : this.props.price;
    const gst = (price / 1.15) * 0.15;
    return (
      <div className={css(styles.container)}>
        <div className={css(styles.heading)}>Order Summary</div>
        <div className={css(styles.membership)}>
          <div className={css(styles.membership_details)}>
            <div className={css(styles.membership_title)}>
              {this.props.membership} Membership
            </div>
            <div className={css(styles.membership_type)}>
              {this.props.type}
              {
                this.props.donationPrice ?
                  ` (inc. $${this.props.donationPrice.toFixed(2)} donation)`
                  : ''
              }
            </div>
          </div>
          <div className={css(styles.membership_price)}>
            ${price.toFixed(2)}
          </div>
        </div>
        <div className={css(styles.totals)}>
          <div className={css(styles.total)}>
            <div className={css(styles.total_label)}>Total</div>
            <div className={css(styles.total_price)}>
              ${price.toFixed(2)}
            </div>
          </div>
          <div style={{ textAlign: 'right', paddingBottom: 15 }}>
            <span style={{ fontSize: 14, color: 'grey' }}>(inc. GST ${gst.toFixed(2)})</span>
          </div>
          {this.props.checkout}
          {this.props.hasError ?
            <div className={css(styles.error)}>
              Please fix any form errors {Theme.isMobile ? 'above ' : null}to continue
            </div>
          : null}
        </div>
        <div className={css(styles.billingNoteWrapper)} >
          <p className={css(styles.billingNote)}>
            Your account will NOT auto-resubscribe.
            To activate your re-subscription go to your My Membership page.
          </p>
        </div>
        {this.props.promoText ?
          <div className={css(styles.promo)}>
            {this.props.promoTitle ?
              <span className={css(styles.promo_title)}>{this.props.promoTitle}</span>
            : null}
            {this.props.promoText}
          </div>
        : null}
      </div>
    );
  }
}

OrderSummary.defaultProps = {
  promoPrice: null,
  promoText: null,
  promoTitle: null,
  donationPrice: 0.00,
};

OrderSummary.propTypes = {
  type: PropTypes.string.isRequired,
  membership: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  donationPrice: PropTypes.number,
  promoPrice: PropTypes.number,
  promoTitle: PropTypes.string,
  promoText: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node).isRequired,
    PropTypes.object,
  ]),
  checkout: PropTypes.node.isRequired,
  hasError: PropTypes.bool.isRequired,
};

const styles = StyleSheet.create({
  error: {
    marginTop: 15,
    textAlign: 'center',
    color: Theme.error,
    fontSize: 14,
    lineHeight: 1.4,
  },
  promo: {
    padding: '15px',
    textAlign: 'center',
    color: '#fff',
    fontSize: 14,
    lineHeight: 1.4,
    backgroundColor: '#021a36',

    ':not(.a) strong': {
      fontWeight: 'bold',
    },
  },
  disclaimer: {
    padding: 15,
    textAlign: 'center',
    fontSize: 14,
    lineHeight: 1.4,
  },
  billingNoteWrapper: {
    padding: '0 20px 30px 20px',
    textAlign: 'center',
  },
  billingNote: {
    fontFamily: Theme.font_family_heading,
    fontWeight: 500,
    fontSize: 13,
    lineHeight: 1.4,
  },
  promo_title: {
    display: 'block',
    textTransform: 'uppercase',
    fontWeight: 'bold',
    marginBottom: 5,
    fontSize: 13,
    letterSpacing: 0.65,
  },
  totals: {
    padding: '35px 30px 30px',
  },
  total: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 22,

    [Theme.mobile_query]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  total_price: {
    [Theme.mobile_query]: {
      marginTop: 10,
    },
  },
  total_price_lg: {
    fontSize: 20,
    fontFamily: Theme.font_family_heading,
    fontWeight: Theme.font_weight_heading,
    color: '#262626',

    [Theme.mobile_query]: {
      marginTop: 10,
    },
  },
  membership: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '35px 30px 30px',
    borderBottom: '1px solid #d8d8d8',

    [Theme.mobile_query]: {
      flexDirection: 'column',
    },
  },
  membership_title: {
    marginBottom: 6,
    fontFamily: Theme.font_family_primary,
    fontSize: 20,
    fontWeight: 500,
    color: '#000e1f',
  },
  membership_type: {
    fontFamily: Theme.font_family_primary,
    fontSize: 14,
    color: '#828282',
  },
  membership_price: {
    textAlign: 'right',
    fontSize: 20,
    fontFamily: Theme.font_family_heading,
    fontWeight: Theme.font_weight_heading,
    color: '#262626',

    [Theme.mobile_query]: {
      textAlign: 'left',
      marginTop: 10,
    },
  },
  container: {
    width: 360,
    minHeight: 100,
    marginBottom: 40,
    boxShadow: '0 3px 4px 0 rgba(171, 171, 171, 0.5)',
    border: 'solid 1px #e4e4e4',
    borderRadius: 5,
    backgroundColor: Theme.white,
    overflow: 'hidden',

    [Theme.mobile_query]: {
      width: '100%',
    },
  },
  heading: {
    height: 50,
    lineHeight: '50px',
    textAlign: 'center',
    backgroundColor: '#021a36',
    color: Theme.white,
    fontFamily: Theme.font_family_primary,
    fontWeight: 500,
    fontSize: 20,
  },
});



// WEBPACK FOOTER //
// ./src/components/OrderSummary/index.js